import * as tslib_1 from "tslib";
import highlightDisplayText from './suggestionsContextMenu/highlightDisplayText';
import { suggestionSelected } from '../actions/publicActions';
import { CLICK_ACTION_SOURCE } from '../searchConstants';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { getFormattedDate } from 'owa-mail-store-actions';
import * as React from 'react';
var styles = require('./SuggestionsContextMenu.scss');
var MessageSuggestionMenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(MessageSuggestionMenuItem, _super);
    function MessageSuggestionMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageSuggestionMenuItem.prototype.render = function () {
        var suggestion = this.props.suggestion;
        var highlightSubjectRegions = highlightDisplayText(suggestion.Subject);
        var highlightDisplayNameRegions = highlightDisplayText(suggestion.DisplayName);
        return (React.createElement("div", { className: styles.messageSuggestion, key: suggestion.Subject, tabIndex: 0, 
            // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
            onMouseDown: function () {
                suggestionSelected(suggestion, CLICK_ACTION_SOURCE);
            }, title: suggestion.Subject },
            React.createElement("div", { className: styles.messageSuggestionFirstLine },
                React.createElement(Icon, { className: styles.suggestionIcon, iconName: "Mail" /* Mail */ }),
                React.createElement("span", { className: styles.messageSuggestionSubject }, highlightSubjectRegions
                    .filter(function (e) { return e.text.length > 0; })
                    .map(createHighlightRegion)),
                React.createElement("span", { className: styles.messageSuggestionDateTime }, suggestion.DateTimeReceived &&
                    getFormattedDate(suggestion.DateTimeReceived))),
            React.createElement("div", { className: styles.messageSuggestionName }, highlightDisplayNameRegions
                .filter(function (e) { return e.text.length > 0; })
                .map(createHighlightRegion))));
    };
    MessageSuggestionMenuItem = tslib_1.__decorate([
        observer
    ], MessageSuggestionMenuItem);
    return MessageSuggestionMenuItem;
}(React.Component));
export default MessageSuggestionMenuItem;
function createHighlightRegion(textRegion) {
    var className = textRegion.isHighlighted
        ? styles.keywordMatchSuggestion
        : styles.keywordNonMatchSuggestion;
    return React.createElement("span", { className: className }, textRegion.text);
}
//# sourceMappingURL=MessageSuggestionMenuItem.js.map